export default class TouchnetError extends Error {}
